import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import type { FieldErrorProps } from "web_myplann/Forms/Hooks/useFieldError";
import {
	MyPlannInput,
	type MyPlannInputProps,
} from "web_myplann/Shared/Components/MyPlannInput";

type Props<FormType extends FieldValues, TName> = MyPlannInputProps &
	FieldErrorProps & {
		control: Control<FormType, object>;
		name: TName;
		onChange?: (
			event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
		) => void;
		useNameForId?: boolean;
		autocomplete?: string;
	};

export const MyPlannFormInput = <
	FormType extends FieldValues = FieldValues,
	TName extends FieldPath<FormType> = FieldPath<FormType>,
>({
	control,
	name,
	useNameForId,
	autocomplete,
	...rest
}: Props<FormType, TName>) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({
				field: { onChange, value, onBlur, ref },
				fieldState: { error },
			}) => (
				<MyPlannInput
					value={value}
					multiline={rest.multiline ?? rest.type !== "password"}
					error={!!error?.message}
					helperText={error?.message}
					onChange={(e) => {
						if (rest.type === "number") {
							const numValue = Number(e.target.value);
							onChange(Number.isNaN(numValue) ? e.target.value : numValue);
						} else {
							onChange(e);
						}
					}}
					onBlur={onBlur}
					inputRef={ref}
					autocomplete={autocomplete ?? "off"}
					{...rest}
					id={useNameForId ? name : rest.id}
				/>
			)}
		/>
	);
};
